import React, { useState, useEffect, useRef } from "react";
import Axios from "../../axios/axios";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useSelector, useDispatch } from "react-redux";
import { ListProducts } from "../../actions/productAction";
import { PDFDownloadLink, Document, Page } from "@react-pdf/renderer";
import ReturnPrint from "./ReturnPrint";
import { Link } from "react-router-dom";
import SaveLoader from "../Common/Loader";

export default function Return() {
  const productList = useSelector((state) => state.productList);
  const { products } = productList;
  const qrInputRef = useRef(null);
  const [searchCustomerLoading, setCustomerLoading] = useState(false);
  const [searchCustomerRes, setResCustomer] = useState("");
  const [customerError, setCustomerError] = useState("");
  console.log();
  const [selectedOrder, setOrderSelected] = useState("");

  const [searchCustomer, setSearchCustomer] = useState("");
  const [productList_, setProductList_] = useState([]);
  const [product, setProduct] = useState("");

  const [orderDetails, setOrderDetails] = useState([]);

  const [stock, setStock] = useState("");
  const [customerDetails, setCustomerDetails] = useState({});

  const [balanceAmount, setBalanceAmount] = useState(0);

  const [date, setDate] = useState(getTodayDate());
  const [stocksList, setStockList] = useState([]);

  const [orders, setOrders] = useState([]);

  const [checkedItems, setCheckedItems] = useState([]);

  const [receivedAmount, setReceivedAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [balance, setBalance] = useState(0);

  const [returnData, setReturnData] = useState("");
  const [qrData, setQrData] = useState(null);
  const [scanMode, setScanMode] = useState("order");
  const [showQRModal, setShowQRModal] = useState(false);
  const [scannedQRData, setScannedQRData] = useState(null);
  const [pendingQRAction, setPendingQRAction] = useState(null);
  const [qrOrderLoading, setQrOrderLoading] = useState(false);
  const [isTypingManually, setIsTypingManually] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");

  console.log("order data", selectedOrder);

  console.log("checked data", checkedItems);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  const customerSearchFunction = async (e) => {
    if (e.keyCode === 13) {
      setSearchCustomer(e.target.value);

      let obj = {
        phone: parseInt(e.target.value),
        pendingReturn: true, 
      };
      const { data } = await Axios.post(`/api/order/return-orders`, obj);

      const data_ = await Axios.get(`/api/user/mob/${e.target.value}`);
      console.log("USER DATA:", data_.data.user);
      console.log("ALL ORDERS COUNT:", data?.data?.length);
      console.log(
        "ALL ORDER USER IDs:",
        data?.data?.map((o) => ({
          orderId: o.orderId,
          userId: o?.user?._id || o?.user,
        })),
      );

      setBalanceAmount(data_.data.user.balanceAmount);
      setCustomerDetails(data_.data.user);

      const filteredOrders = data?.data?.filter((order) => {
        const orderUserId =
          order?.user?._id?.toString() || order?.user?.toString();
        return orderUserId === data_.data.user._id?.toString();
      });

      // ✅ ADD THIS: only show orders that have items pending return
      const ordersWithPendingReturns = filteredOrders.filter((order) =>
        order?.orderItems?.some(
          (item) => item.isDelivered === true && item.isReturn === false,
        ),
      );

      if (ordersWithPendingReturns.length === 0) {
        setCustomerError("No order found !");
      } else {
        setCustomerError(`${ordersWithPendingReturns.length} order found`);
        setOrders(ordersWithPendingReturns); // ← use filtered list
      }
      console.log("ALL ORDERS:", data?.data);
      console.log("FILTERED ORDERS:", filteredOrders);
    }
  };
  console.log("order details", orders);

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    getProductList(selectedOrder);
  }, [selectedOrder]);

  console.log("date", date);

  const getProductList = (orderId) => {
    let data = orders?.find((lt) => lt._id === orderId);
    setOrderDetails(data);
    let orderItems = data?.orderItems?.filter(
      (data) => data.isDelivered === true && data.isReturn === false,
    );

    // const matchingObjects = products?.filter((item1) =>
    //   orderItems?.some((item2) => item2.product === item1._id)
    // );

    setStockList(orderItems);
    // let productsList = products?.find((data)=>data)
    console.log("RAW orderItems:", data?.orderItems);
  };

  const changeProduct = (val) => {
    setProduct(val);
    getStockFormProduct(val);
  };

  const getStockFormProduct = async (id) => {
    await Axios.get(`/api/products/${id}`).then((res) => {
      setStockList(res?.data?.stock);
    });
  };

  const productName = (proId) => {
    let data = products.filter((data) => data._id === proId);

    return data.length > 0 ? data?.[0].name : "";
  };

  const changeTick = (val) => {
    console.log(checkedItems, "checkedItems");
    console.log(val, "val");
    let isExist = checkedItems?.some((data) => data.stock === val.stock);

    console.log(isExist, "isExist");

    if (isExist === true) {
      setCheckedItems((checkedItems) =>
        checkedItems.filter((obj) => obj._id !== val._id),
      );
    } else {
      setCheckedItems((checkedItems) => [...checkedItems, val]);
    }
  };
  console.log("returned items", checkedItems);

  const [status, setStatus] = useState("");
  const [orderData, setOrderData] = useState("");
  const [loader, setLoader] = useState(false);

  console.log(customerDetails?.name);

  const [afterReturnOrder, setAfterReturnOrder] = useState({});
  const [finalOrderForPrint, setFinalOrderForPrint] = useState(null);
  const [printOrder, setPrintOrder] = useState(null);

  const returnFnc = async () => {
    setLoader(true);

    if (window.confirm("Are you sure want return this item")) {
      // 1️⃣ RETURN ITEMS
      for (let index = 0; index < checkedItems.length; index++) {
        await Axios.post(`/api/order/return`, {
          orderId: selectedOrder,
          product: checkedItems[index].product,
          stock: checkedItems[index].stock,
          date,
        });
      }

      // 2️⃣ ADD PAYMENT (🔥 IMPORTANT)
      if (receivedAmount > 0) {
        await Axios.post(`/api/order/add-payment`, {
          orderId: selectedOrder,
          amount: receivedAmount,
          paymentMethod,
          module: "return",
        });
      }

      // 3️⃣ REFRESH ORDER
      const updatedOrder = await Axios.get(`/api/order/${selectedOrder}`);
      setOrderDetails(updatedOrder.data);
      setPrintOrder(updatedOrder.data);

      toast.success("Return Successfully!");

      setLoader(false);
      setStatus(true);
    }
  };

  const [orderItem, setOrderItem] = useState("");

  const getOrder = async () => {
    console.log("Order ID:", selectedOrder); // Log orderId to check its value
    // try {
    //   const orderResponse = await Axios.get(`/api/order/${orderId}`);
    //   console.log('Order Response:', orderResponse.data);
    //      setOrderItem(orderResponse.data)
    // const returnedItem = orderItem.filter(item => item.isReturn === true)
    // const returnedItemsArray = []
    // returnedItemsArray.push(...returnedItem)
    // console.log('Returned Items Array:', returnedItemsArray);
    //   // Continue processing the order data////////////////////////////
    // } catch (error) {
    //   console.error('Error fetching order:', error);
    // }
  };

  const handleAmount = (val, type) => {
    if (type === 0) {
      setReceivedAmount(val);
    } else {
      setDiscount(val);
    }

    setBalance(balanceAmount - val);
  };
  const calculateBalance = () => {
    const orderBalance = getSelectedOrderBalance();

    const received = parseInt(receivedAmount || 0);
    const disc = parseInt(discount || 0);

    let bal = orderBalance - (received + disc);

    return bal < 0 ? 0 : bal;
  };

  console.log(customerDetails);
  console.log(searchCustomer);

  const handleReturnedQR = (text) => {
    let parsed = null;

    try {
      parsed = JSON.parse(text);
    } catch {
      toast.error("Invalid QR format");
      return;
    }

    if (!parsed.invoiceId || !parsed.customerNumber) {
      toast.error("Invalid QR - missing invoice or phone");
      return;
    }

    // Save scanned data
    setScannedQRData(parsed);
    setPendingQRAction("ORDER");
    setShowQRModal(true);
  };

  const handleConfirmQR = async () => {
    if (!scannedQRData) return;

    setShowQRModal(false);
    setQrOrderLoading(true); // Show loader

    if (pendingQRAction === "ORDER") {
      await processReturnQR(scannedQRData);
    }

    setScannedQRData(null);
    setPendingQRAction(null);
    setQrOrderLoading(false); // Hide loader

    setTimeout(() => {
      if (qrInputRef.current) {
        qrInputRef.current.focus();
      }
    }, 100);
  };

  const handleCancelQR = () => {
    setShowQRModal(false);
    setScannedQRData(null);
    setPendingQRAction(null);

    setTimeout(() => {
      if (qrInputRef.current) {
        qrInputRef.current.focus();
      }
    }, 100);
  };

  const processReturnQR = async (qr) => {
    try {
      setQrData(qr);

      // Step 1: Load customer orders
      const fakeEvent = {
        keyCode: 13,
        target: { value: qr.customerNumber },
      };

      await customerSearchFunction(fakeEvent);
    } catch (error) {
      toast.error("Failed to load customer orders");
      console.error(error);
    }
  };

  const handleProductQR = (text) => {
    let parsed = null;

    try {
      parsed = JSON.parse(text);
    } catch {
      parsed = { itemCode: text };
    }

    const itemCode = parsed.itemCode || parsed.stock || text;

    if (!itemCode) {
      toast.error("Invalid product QR code - no item code found");
      return;
    }

    if (!selectedOrder) {
      toast.error("Please select an order first before scanning products");
      return;
    }
    const matchingProduct = stocksList?.find(
      (item) => item.stock === itemCode || item.serialNumber === itemCode,
    );

    if (!matchingProduct) {
      toast.error(
        `Product with item code "${itemCode}" not found in this order`,
      );
      return;
    }

    const alreadySelected = checkedItems?.some(
      (data) => data.stock === matchingProduct.stock,
    );

    if (alreadySelected) {
      toast.info(`Product "${itemCode}" is already selected`);
      return;
    }

    changeTick(matchingProduct);
    toast.success(`✓ Product "${itemCode}" selected for return`, {
      position: "top-center",
      autoClose: 2000,
    });
  };

  useEffect(() => {
    if (!qrData) return;
    if (orders.length === 0) return;

    console.log("Orders loaded, matching order...");

    const match = orders.find(
      (o) => parseInt(o.orderId) === parseInt(qrData.invoiceId),
    );

    if (!match) {
      toast.error("Order not found");
      return;
    }

    console.log("Order matched:", match);

    setOrderSelected(match._id);

    setTimeout(() => {
      setScanMode("product");
      toast.info("Order loaded! Now scan products to select them for return", {
        position: "top-center",
        autoClose: 3000,
      });
    }, 1000);
  }, [orders]);

  useEffect(() => {
    const interval = setInterval(() => {
      // Check if user is typing in ANY input, select, or textarea
      const activeEl = document.activeElement;
      const isUserTyping =
        activeEl?.tagName === "INPUT" ||
        activeEl?.tagName === "SELECT" ||
        activeEl?.tagName === "TEXTAREA" ||
        activeEl?.tagName === "BUTTON";

      // Only refocus QR input if user is NOT interacting with any form element
      if (!isUserTyping && qrInputRef.current) {
        qrInputRef.current.focus();
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (selectedOrder) {
      setScanMode("product");
      toast.info("Order selected! You can now scan product item codes", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  }, [selectedOrder]);

  const getCorrectOrderAmount = (order) => {
    if (!order || !order.orderItems || order.orderItems.length === 0) {
      return order?.orderAmount || 0;
    }

    const calculatedAmount = order.orderItems.reduce((total, item) => {
      const itemAmount =
        (item.prodPrice || 0) * (item.qnty || 1) * (item.days || 1);
      return total + itemAmount;
    }, 0);

    return calculatedAmount > 0 ? calculatedAmount : order?.orderAmount || 0;
  };

  const getSelectedOrderBalance = () => {
    if (!selectedOrder || !orderDetails) {
      return 0;
    }

    const correctAmount = getCorrectOrderAmount(orderDetails);
    const totalReceived = orderDetails.totalReceive || 0;
    const totalDiscount = orderDetails.discount || 0;

    const orderBalance = correctAmount - totalReceived - totalDiscount;

    return orderBalance > 0 ? orderBalance : 0;
  };

  const getTotalCustomerBalance = () => {
    if (!orders || orders.length === 0) {
      return 0;
    }

    const totalBalance = orders.reduce((total, order) => {
      const correctAmount = getCorrectOrderAmount(order);
      const totalReceived = order.totalReceive || 0;
      const totalDiscount = order.discount || 0;
      const orderBalance = correctAmount - totalReceived - totalDiscount;

      return total + (orderBalance > 0 ? orderBalance : 0);
    }, 0);

    return totalBalance;
  };

  // FIXED: Calculate total amount of returned items
  const calculateReturnedItemsTotal = () => {
    return checkedItems.reduce((total, item) => {
      const itemAmount =
        (item.prodPrice || 0) * (item.qnty || 1) * (item.days || 1);
      return total + itemAmount;
    }, 0);
  };

  // FIXED: Prepare payment details for PDF
  const getPaymentDetailsForPDF = () => {
    const returnedTotal = calculateReturnedItemsTotal();
    const received = parseFloat(receivedAmount) || 0;
    const discountAmt = parseFloat(discount) || 0;
    const balanceAmt = returnedTotal - received - discountAmt;

    return {
      totalAmount: returnedTotal,
      received: received,
      discount: discountAmt,
      balance: balanceAmt,
    };
  };

  const isAllSelected =
    stocksList?.length > 0 && checkedItems.length === stocksList.length;

  const toggleSelectAll = () => {
    if (!stocksList || stocksList.length === 0) return;

    if (isAllSelected) {
      setCheckedItems([]);
    } else {
      setCheckedItems([...stocksList]);
    }
  };

  const handlePreparePrint = async () => {
    if (!selectedOrder) return;

    const { data } = await Axios.get(`/api/order/${selectedOrder}`);
    setPrintOrder(data);
  };

  return (
    <div className="card p-3">
      <ToastContainer />

      <SaveLoader setIsLoading={setLoader} isLoading={loader} />
      <SaveLoader setIsLoading={setQrOrderLoading} isLoading={qrOrderLoading} />

      <div class="row  p-2">
        <div class="col-md-8 grid-margin transparent">
          <div class="row">
            <div class="col-md-6 mb-4 stretch-card transparent">
              <div class="card card-tale">
                <div class="card-body">
                  <p class="mb-4">Customer</p>
                  <div class="d-flex">
                    <div class="p-2">
                      {" "}
                      <input
                        type="search"
                        className="form-control"
                        placeholder="Search number here"
                        value={searchCustomer}
                        onChange={(e) => setSearchCustomer(e.target.value)}
                        onKeyDown={(e) => customerSearchFunction(e)}
                      />
                    </div>
                  </div>
                  <div>
                    {searchCustomerLoading === true ? (
                      <div class="spinner-border ml-5" role="status">
                        <span class="sr-only ">Loading...</span>
                      </div>
                    ) : (
                      <span>
                        {" "}
                        {searchCustomerRes}{" "}
                        <div className="p-3"> {customerError}</div>
                      </span>
                    )}
                  </div>
                  {selectedOrder ? (
                    <>
                      <div
                        style={{ fontSize: 14, color: "#666", marginBottom: 5 }}
                      >
                        Order Balance:
                      </div>
                      <span
                        style={{
                          fontSize: 20,
                          fontWeight: "bolder",
                          color: "#d63636",
                        }}
                      >
                        ₹ {getSelectedOrderBalance()}
                      </span>
                    </>
                  ) : (
                    <>
                      Total Balance:{" "}
                      <span
                        style={{
                          fontSize: 20,
                          fontWeight: "bolder",
                          color: "#d63636",
                        }}
                      >
                        ₹ {getTotalCustomerBalance()}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-4 stretch-card transparent">
              <div class="card card-tale">
                <div class="card-body">
                  <p class="mb-4">Select Order</p>
                  <select
                    className="form-control"
                    required
                    onChange={(e) => {
                      setOrderSelected(e.target.value);
                      if (e.target.value) {
                        setScanMode("product");
                      }
                    }}
                    value={selectedOrder}
                  >
                    <option value="">Select Order</option>
                    {orders?.map((data) => (
                      <option value={data._id}>ADC_{data.orderId}</option>
                    ))}
                  </select>
                  <label for="exampleInputName">Return Date</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => setDate(e.target.value)}
                    required={true}
                    value={date}
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row card m-1">
            <div class="col-md-12 grid-margin transparent">
              {" "}
              <div class="table-responsive">
                <p>
                  Ordered Items (
                  <span style={{ color: "red", fontSize: "1rem" }}>
                    select one item to return
                  </span>
                  ) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; There
                  is{" "}
                  <span style={{ fontSize: "15px" }}>
                    {stocksList === undefined
                      ? 0
                      : stocksList?.length - checkedItems?.length}{" "}
                  </span>{" "}
                  item pending for return in your order
                </p>

                <table
                  class="display expandable-table"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>Number</th>
                      <th>Product</th>
                      <th>Item Code</th>
                      <th>Sl No</th>
                      <th>Delivered At</th>
                      <th>
                        <input
                          type="checkbox"
                          checked={isAllSelected}
                          onChange={toggleSelectAll}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {stocksList && stocksList.length > 0 ? (
                      stocksList?.map((data, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{productName(data.product)}</td>
                          <td>{data.stock}</td>
                          <td>{data.serialNumber}</td>
                          <td>{data.deliveredAt}</td>

                          <td>
                            <input
                              type="checkbox"
                              checked={checkedItems?.some(
                                (item) => item.stock === data.stock,
                              )}
                              onChange={(e) => changeTick(data)}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center text-black">
                          No Items Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 grid-margin transparent" style={{ color: "blue" }}>
          <div class="row">
            <div class="card  ">
              <div class="card-body">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                  <label>Received</label>
                  <input
                    type="number"
                    className="form-control mb-2"
                    placeholder="Received Amount"
                    value={receivedAmount}
                    onChange={(e) => handleAmount(e.target.value, 0)}
                    min={0}
                  />
                </div>
                <div class="col-12  col-sm-12 col-md-12 col-lg-12 mb-2">
                  <label>Discount</label>
                  <input
                    type="number"
                    className="form-control mb-2"
                    placeholder="Discount"
                    value={discount}
                    onChange={(e) => handleAmount(e.target.value, 1)}
                  />
                </div>
                <div class="col-12 mb-2">
                  <label>Payment Method</label>
                  <select
                    className="form-control mb-2"
                    value={paymentMethod}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                  >
                    <option value="cash">Cash</option>
                    <option value="upi">UPI</option>
                  </select>
                </div>
                <div class="col-12  col-sm-12 col-md-12 col-lg-12 mb-2">
                  <div> Balance :₹ {calculateBalance()}</div>
                </div>
                <div className="row">
                  <div class="col-4  col-sm-4 col-md-4 col-lg-4 mb-2">
                    {loader ? (
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden"></span>
                      </div>
                    ) : (
                      <div class="col-12  col-sm-12 col-md-12 col-lg-12 mb-2">
                        <button
                          type="button"
                          class="btn btn-success mt-2"
                          data-toggle="modal"
                          data-target="#bookNowModal"
                          disabled={checkedItems.length === 0 ? true : false}
                          onClick={() => returnFnc()}
                          style={{ width: "100px" }}
                        >
                          Submit
                        </button>
                      </div>
                    )}
                  </div>
                  <div class="col-4 col-sm-4 col-md-4 col-lg-4 mb-2">
                    {printOrder ? (
                      <PDFDownloadLink
                        document={
                          <ReturnPrint
                            products={products}
                            amountDetails={{
                              totalAmount: printOrder.orderAmount,
                              received: printOrder.totalReceive,
                              returnDiscount: printOrder.discount,
                              finalBalance:
                                printOrder.orderAmount -
                                printOrder.totalReceive -
                                printOrder.discount,
                            }}
                            customerName={customerDetails?.name}
                            address={customerDetails?.address1}
                            customerNumber={searchCustomer}
                            invoiceId={printOrder?.orderId}
                            returnDate={date}
                            items={checkedItems}
                            returnData={afterReturnOrder}
                          />
                        }
                        fileName={`${customerDetails?.name}Return.pdf`}
                      >
                        {({ loading }) => (
                          <button
                            type="button"
                            class="btn btn-success"
                            style={{ width: "100px" }}
                          >
                            Print
                          </button>
                        )}
                      </PDFDownloadLink>
                    ) : null}
                  </div>

                  <div class="col-4  col-sm-4 col-md-4 col-lg-4 mb-2">
                    <Link to={"/"} style={{ width: "100px" }}>
                      <div className="btn btn-danger">cancel</div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Hidden QR input */}
      <input
        id="qr-hidden-input"
        ref={qrInputRef}
        type="text"
        autoFocus
        style={{
          position: "fixed",
          top: 0,
          left: -9999,
          width: 1,
          height: 1,
          opacity: 0,
          pointerEvents: "none",
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            const text = e.target.value.trim();
            e.target.value = "";

            if (scanMode === "order") {
              handleReturnedQR(text);
            } else if (scanMode === "product") {
              handleProductQR(text);
            }

            setTimeout(() => {
              if (qrInputRef.current) {
                qrInputRef.current.focus();
              }
            }, 100);
          }
        }}
        onBlur={() => {
          setTimeout(() => {
            const activeEl = document.activeElement;
            const isUserTyping =
              activeEl?.tagName === "INPUT" ||
              activeEl?.tagName === "SELECT" ||
              activeEl?.tagName === "TEXTAREA";

            if (!isUserTyping && qrInputRef.current) {
              qrInputRef.current.focus();
            }
          }, 10);
        }}
      />
      {showQRModal && scannedQRData && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={(e) => {
            // Close modal if clicking outside
            if (e.target === e.currentTarget) {
              handleCancelQR();
            }
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              padding: 30,
              width: 450,
              maxWidth: "90%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
                handleConfirmQR();
              } else if (e.key === "Escape") {
                e.preventDefault();
                e.stopPropagation();
                handleCancelQR();
              }
            }}
            tabIndex={0}
            ref={(el) => {
              if (el) {
                setTimeout(() => {
                  el.focus();
                }, 50);
              }
            }}
          >
            <h4
              style={{ marginBottom: 20, color: "#333", textAlign: "center" }}
            >
              Order Found!
            </h4>

            <div style={{ marginBottom: 25, fontSize: 15 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 12,
                  paddingBottom: 12,
                  borderBottom: "1px solid #eee",
                }}
              >
                <strong style={{ color: "#666" }}>Invoice:</strong>
                <span style={{ color: "#000", fontWeight: 500 }}>
                  ADC_{scannedQRData.invoiceId}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 12,
                  paddingBottom: 12,
                  borderBottom: "1px solid #eee",
                }}
              >
                <strong style={{ color: "#666" }}>Phone:</strong>
                <span style={{ color: "#000", fontWeight: 500 }}>
                  {scannedQRData.customerNumber}
                </span>
              </div>
            </div>

            <div
              style={{
                fontSize: 14,
                color: "#666",
                marginBottom: 20,
                textAlign: "center",
              }}
            >
              Proceed with this order?
            </div>

            <div
              style={{
                display: "flex",
                gap: 10,
                justifyContent: "flex-end",
                marginTop: 25,
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={handleCancelQR}
                style={{ minWidth: 100 }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleCancelQR();
                  }
                }}
              >
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={handleConfirmQR}
                style={{ minWidth: 100 }}
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleConfirmQR();
                  }
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
